<template>
  <!--
      作者：gmshop
      时间：2019-10-25
      描述：订单列表
  -->
  <div class="user">
    <!--搜索表单-->
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline">
        <el-form-item label="订单号"><el-input size="small" clearable  v-model="searchForm.order_no" placeholder="请输入订单号"></el-input></el-form-item>
        <el-form-item label="买家ID">
          <el-input size="small" style="width:100px" clearable  v-model="searchForm.user_id" placeholder="买家ID"></el-input>
        </el-form-item>
        <el-form-item label="买家昵称">
          <el-input size="small" style="width:150px" clearable  v-model="searchForm.nickname" placeholder="买家昵称"></el-input>
        </el-form-item>
        <el-form-item label="收货人">
          <el-input size="small" style="width:120px" clearable  v-model="searchForm.address" placeholder="姓名或手机"></el-input>
        </el-form-item>

        <el-form-item label="商品分类">
          <el-select v-model="searchForm.category_id" clearable >
            <template v-for="cat in categoryList">
              <el-option :value="cat.category_id" :key="cat.category_id" :label="cat.name"></el-option>
              <template v-if="cat.child !== undefined" v-for="two in cat.child">
                <el-option :value="two.category_id" :key="two.category_id" :label="two.name" style="padding-left: 30px;"></el-option>
                <template v-if="two.child !== undefined" v-for="three in two.child">
                  <el-option :value="three.category_id" :key="three.category_id" :label="three.name" style="padding-left: 60px;"></el-option>
                </template>
              </template>
            </template>
          </el-select>
        </el-form-item>
        <el-form-item label="商品名称">
          <el-input size="small" style="width:150px" clearable  v-model="searchForm.product_name" placeholder="商品名称"></el-input>
        </el-form-item>
        <el-form-item label="商品编号">
          <el-input size="small" style="width:150px" clearable  v-model="searchForm.product_no" placeholder="商品编号"></el-input>
        </el-form-item>
        <el-form-item label="快递单号">
          <el-input size="small" style="width:150px" clearable  v-model="searchForm.express_no" placeholder="快递单号"></el-input>
        </el-form-item>
        <el-form-item label="推荐人ID">
          <el-input size="small" style="width:100px" clearable  v-model="searchForm.referee_id" placeholder="推荐人ID"></el-input>
        </el-form-item>
        <el-form-item label="配送方式">
          <el-select size="small" clearable  v-model="searchForm.style_id" placeholder="请选择">
            <el-option label="全部" value=""></el-option>
            <el-option v-for="(item, index) in exStyle" :key="index" :label="item.name" :value="item.value"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="自提门店">
          <el-select size="small" clearable  v-model="searchForm.store_id" placeholder="请选择">
            <el-option label="全部" value=""></el-option>
            <el-option v-for="(item, index) in shopList" :key="index" :label="item.store_name" :value="item.store_id"></el-option>
          </el-select>
        </el-form-item>


        <el-form-item label="付款方式">
          <el-select size="small" clearable  v-model="searchForm.pay_type" placeholder="请选择">
            <el-option label="全部" value=""></el-option>
            <el-option v-for="(item, index) in payType" :key="index" :label="item.name" :value="item.value"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="起始时间">
          <div class="block">
            <span class="demonstration"></span>
            <el-date-picker
              size="small"
              v-model="searchForm.create_time"
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            ></el-date-picker>
          </div>
        </el-form-item>
        <el-form-item label="配送时间" v-if="show_Distribution == true">
          <div class="block">
              <span class="demonstration"></span>
              <el-date-picker
                v-model="searchForm.current_time"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="选择日期">
              </el-date-picker>
            </div>
        </el-form-item>
        <el-form-item><el-button size="small" type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button></el-form-item>
        <el-form-item>
          <el-button size="small" type="primary"  v-auth="'/order/operate/export'"  @click="onExport" >导出</el-button>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary"  v-auth="'/order/operate/export'" @click="editeClick" >自定义导出</el-button>
        </el-form-item>
        <el-form-item v-auth="'/order/delivery/csv'">
            <el-button type="primary" @click="openUpload">批量发货</el-button>
          </el-form-item>
        <el-form-item v-auth="'/product/product/syncWanliniu'" >
            <el-button type="primary" @click="syncWanliniu(0,1)">批量同步万里牛</el-button>
          </el-form-item>
      </el-form>
    </div>
    <!--内容-->
    <div class="product-content">
      <div class="table-wrap order_table-wrap">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="全部订单" name="all"></el-tab-pane>
          <el-tab-pane :label="'未付款(' + order_count.payment + ')'" name="payment"></el-tab-pane>
          <el-tab-pane :label="'待发货(' + order_count.delivery + ')'" name="delivery"></el-tab-pane>
          <el-tab-pane :label="'申请取消(' + order_count.apply_cancle + ')'" name="apply_cancle"></el-tab-pane>
          <el-tab-pane :label="'待收货(' + order_count.received + ')'" name="received"></el-tab-pane>
          <el-tab-pane label="待评价" name="comment"></el-tab-pane>
          <el-tab-pane label="已完成" name="six"></el-tab-pane>
        </el-tabs>
        <el-table size="small" :data="tableData.data" :span-method="arraySpanMethod" border style="width: 100%" v-loading="loading"  :row-key="getRowKey"  @selection-change="tableCurrentChange">
          <el-table-column type="selection" :reserve-selection="true" :selectable="checkSelect" align="center" width="45" ></el-table-column>
          <el-table-column prop="order_no" label="订单信息" width="400">
            <template slot-scope="scope">
              <div class="order-code" v-if="scope.row.is_top_row">
                <span class="state-text" :class="{'state-text-red':scope.row.order_source != 10}">{{scope.row.order_source_text}}</span>
                <span class="c_main">订单号：{{ scope.row.order_no }}</span>
                <span class="pl16">下单时间：{{ scope.row.create_time }}</span>
                <span class="pl16">备注信息：<span class="red">{{ scope.row.buyer_remark }}</span></span>
              </div>
              <template v-else>
                <div class="product-info" v-for="(item, index) in scope.row.product" :key="index">
                  <div class="pic"><img v-img-url="item.image.file_path" alt="" /></div>
                  <div class="info">
                    <div class="name gray3 product-name">
                      <span>{{ item.product_name }}</span>
                    </div>
                    <div class="gray9" v-if="item.product_attr">{{ item.product_attr }}</div>
                    <div class="orange" v-if="item.refund">{{ item.refund.type.text }}-{{ item.refund.status.text }}</div>
                  </div>
                  <div class="d-c-c d-c">
                    <div class="orange">￥ {{ item.product_price }}</div>
                    <div class="gray3">x{{ item.total_num }}</div>
                  </div>
                </div>
              </template>
            </template>
          </el-table-column>
          <el-table-column prop="pay_price" label="实付款">
            <template slot-scope="scope" v-if="!scope.row.is_top_row">
              <div class="orange">{{ scope.row.pay_price }}</div>
              <p class="gray9">(含运费：{{ scope.row.express_price }})</p>
            </template>
          </el-table-column>
          <el-table-column prop="" label="买家">
            <template slot-scope="scope" v-if="!scope.row.is_top_row">
              <div v-if="scope.row.user && scope.row.user.nickName">{{ scope.row.user.nickName }}</div>
              <div class="gray9" v-if="scope.row.user && scope.row.user.user_id">ID：({{ scope.row.user.user_id }})</div>
            </template>
          </el-table-column>
          <el-table-column prop="state_text" label="交易状态">
            <template slot-scope="scope" v-if="!scope.row.is_top_row">
              {{ scope.row.state_text }}
              <p v-if="scope.row.erp_status>0 ">
                <el-tag size="mini">已同步erp订单</el-tag>
              </p>
              <p v-if="scope.row.erp_status==-1 ">
                <el-tag size="mini">erp同步失败</el-tag>
              </p>
            </template>
          </el-table-column>
          <el-table-column prop="pay_type.text" label="支付方式">
            <template slot-scope="scope" v-if="!scope.row.is_top_row">
              <span class="gray9">{{ scope.row.pay_type.text }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="delivery_type.text" label="配送方式">
            <template slot-scope="scope" v-if="!scope.row.is_top_row">
              <span class="green">{{ scope.row.delivery_type.text }}</span>
              <span v-if="scope.row.delivery_type.value == 30">手机号:{{scope.row.user.mobile}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="current_time" label="配送时间" v-if="show_Distribution == true"></el-table-column>
          <el-table-column prop="is_comment" label="评价" width="60">
            <template slot-scope="scope" v-if="!scope.row.is_top_row">
              <span v-if="scope.row.is_comment == 0">未评价</span>
              <span v-else>已评价</span>
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="130">
            <template slot-scope="scope" v-if="!scope.row.is_top_row">
              <el-button @click="addClick(scope.row)" type="text" size="small" v-auth="'/order/order/detail'">订单详情</el-button>
              <el-button
                v-if="scope.row.pay_type.value == 60 && scope.row.pay_image_status.value == 10 && scope.row.order_status.value != 20"
                @click="editClick(scope.row,'pay_image')"
                type="text"
                size="small"
                v-auth="'/order/order/pay_image'"
                >
                去审核
              </el-button>
              <el-button
                v-if="scope.row.pay_status.value == 20 && scope.row.delivery_status.value == 10
                && scope.row.order_status.value != 20 && scope.row.order_status.value != 21
                && scope.row.delivery_type.value == 10 && scope.row.shipment_type == 2"
                type="text"
                size="small"
                >
                部分发货
              </el-button>
              <el-button
                v-if="scope.row.erp_status==0 && scope.row.pay_status.value == 20 && scope.row.delivery_status.value == 10
                && scope.row.order_status.value != 20 && scope.row.order_status.value != 21
                && scope.row.delivery_type.value == 10"
                @click="editClick(scope.row,'express')"
                type="text"
                size="small"
                v-auth="'/order/order/delivery'"
                >
                去发货
              </el-button>
              <el-button
                v-if="scope.row.pay_status.value == 20 && scope.row.delivery_status.value == 10
                && scope.row.order_status.value != 20 && scope.row.order_status.value != 21
                && scope.row.delivery_type.value == 10 && scope.row.shipment_type == 2"
                @click="cancelExpress(scope.row)"
                type="text"
                size="small"
                v-auth="'/order/order/cancelExpress'"
                >
                取消发货
              </el-button>
              <el-button
                v-if="scope.row.pay_status.value == 20
                && (scope.row.delivery_status.value == 20||(scope.row.delivery_type.value == 10 && scope.row.shipment_type == 2))"
                @click="editClick(scope.row,'track')"
                type="text"
                size="small"
                v-auth="'/order/express/track'"
              >
                物流轨迹
              </el-button>
              <el-button
                v-if="scope.row.pay_status.value == 20 && scope.row.delivery_status.value == 10
                && scope.row.order_status.value != 20 && scope.row.order_status.value != 21
                && scope.row.delivery_type.value == 20"
                @click="editClick(scope.row,'extract')"
                type="text"
                size="small"
                v-auth="'/order/operate/extract'"
              >
                去核销
              </el-button>
              <el-button
                v-if="scope.row.pay_status.value == 20 && scope.row.delivery_status.value == 10
                && scope.row.order_status.value != 20 && scope.row.order_status.value != 21
                && scope.row.delivery_type.value == 60"
                @click="editClick(scope.row,'extract')"
                type="text"
                size="small"
              >
                去核销
              </el-button>
              <el-button
                v-if="scope.row.pay_status.value == 20 && scope.row.delivery_status.value == 20
                && scope.row.order_status.value != 20 && scope.row.order_status.value != 21
                && scope.row.receipt_status.value == 10"
                @click="receiptClick(scope.row)"
                type="text"
                size="small"
                v-auth="'/order/order/receipt'"
              >
                去收货
              </el-button>
              <el-button
                v-if="scope.row.pay_status.value == 20 && scope.row.delivery_status.value == 10
                && scope.row.order_status.value != 20 && scope.row.order_status.value != 21
                && scope.row.delivery_type.value == 50"
                @click="distribution(scope.row)"
                type="text"
                size="small"
              >
                去配送
              </el-button>
              <el-button
                v-if="scope.row.pay_status.value == 20 && scope.row.delivery_status.value == 20
                && scope.row.order_status.value == 30 && scope.row.pay_type.value == 50
                && scope.row.receipt_status.value == 20 && scope.row.delivery_pay_status.value == 10"
                @click="payment(scope.row)"
                type="text"
                size="small"
                v-auth="'/order/order/orderPayment'"
              >
                确认付款
              </el-button>
              <el-button
                v-if="scope.row.pay_status.value == 10
                && scope.row.order_status.value != 20
                "
                @click="cancelClick(scope.row)"
                type="text"
                size="small"
                 v-auth="'/order/order/cancel'"
              >
                取消订单
              </el-button>
              <el-button v-if="scope.row.order_status.value == 21" @click="addClick(scope.row)" type="text" size="small" v-auth="'/order/operate/confirmCancel'">去审核</el-button>
              <el-button
                @click="syncJushuitan(scope.row.order_id)"
                type="text"
                size="small"
                v-if="scope.row.erp_status==0 && scope.row.pay_status.value == 20 && scope.row.delivery_status.value == 10
                && scope.row.order_status.value != 20 && scope.row.order_status.value != 21
                && scope.row.delivery_type.value == 10"
                 v-auth="'/product/product/syncJushuitan'" 
              >
                同步聚水潭erp
              </el-button>
              <el-button
                @click="syncWanliniu(scope.row.order_id)"
                type="text"
                size="small"
                v-if="scope.row.erp_status==0 && scope.row.pay_status.value == 20 && scope.row.delivery_status.value == 10
                && scope.row.order_status.value != 20 && scope.row.order_status.value != 21
                && scope.row.delivery_type.value == 10"
                 v-auth="'/product/product/syncWanliniu'" 
              >
                同步万里牛erp
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-sizes="[20, 50, 100, 200, 300, 500]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>
    <FileUpload v-if="open_add" :open_add="open_add"  @closeDialog="closeDialogFunc($event, 'add')"></FileUpload>

    <Express v-if="open_dialog.express" :dataModel="dataModel" @closeDialog="closeDialogFunc($event, 'express')"></Express>
    <Track v-if="open_dialog.track" :dataModel="dataModel" @closeDialog="closeDialogFunc($event, 'track')"></Track>
    <Extract v-if="open_dialog.extract" :dataModel="dataModel" @closeDialog="closeDialogFunc($event, 'extract')"></Extract>
    <FileExport v-if="open_dialog.fileExport" @closeDialog="closeDialogFunc($event, 'fileExport')"></FileExport>
    <PayImage v-if="open_dialog.pay_image" :dataModel="dataModel" @closeDialog="closeDialogFunc($event, 'pay_image')"></PayImage>
  </div>
</template>

<script>
import OrderApi from '@/api/order.js';
import qs from 'qs';
import FileUpload from './dialog/FileUpload';
import Extract from './dialog/Extract.vue';
import Express from './dialog/Express.vue';
import Track from './dialog/Track.vue';
import FileExport from './dialog/FileExport.vue';
import PayImage from './dialog/PayImage.vue';
export default {
  components: {
    /*图片上传*/
    FileUpload: FileUpload,
    /*订单核销*/
    Extract,
    /*快速发货*/
    Express,
    /*物流轨迹*/
    Track,
    /*订单导出*/
    FileExport,
    /*审核付款凭证支付*/
    PayImage
  },
  data() {
    return {
      /*是否打开批量发货弹窗*/
      open_add: false,
      /*是否打开订单导出弹窗*/

      /*切换菜单*/
      activeName: 'all',
      /*是否加载完成*/
      loading: true,
      /*列表数据*/
      tableData: [],
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*横向表单数据模型*/
      searchForm: {
        user_id: "",
        referee_id: "",
        order_no: "",
        nickname: "",
        product_name: "",
        express_no: "",
        product_no: "",
        category_id: "",
        address: "",
        style_id: '',
        store_id: '',
        pay_type: '',
        create_time: '',
        current_time: ''
      },
      /*付款方式*/
      payType: [],
      /*配送方式*/
      exStyle: [],
      /*门店列表*/
      shopList: [],
      /*分类列表*/
      categoryList: [],
      /*时间*/
      create_time: '',
      /*统计*/
      order_count: {
        payment: 0,
        delivery: 0,
        received: 0,
        apply_cancle:0,
      },
      open_dialog: {
        /*快速发货*/
        express: false,
         /*物流轨迹*/
        track: false,
        /*订单核销*/
        extract:false,
        /*订单导出*/
        fileExport:false,
        /*付款凭证支付*/
        pay_image:false,
        },
      datascheck: ["订单号","商品信息","订单总额","优惠券抵扣","积分抵扣","运费金额","后台改价","实付款金额","支付方式","下单时间","买家","买家留言","配送方式","自提门店名称","自提联系人","自提联系电话","收货人姓名","联系电话","收货人地址","物流公司","物流单号","付款状态","付款时间","发货状态","发货时间","收货状态","收货时间","订单状态","微信支付交易号","是否已评价"],
      dete: {
        user_id: "",
        order_no: "",
        nickname: ""
        },
      data1: 'all',

      dataModel:{},
      /*权限检测*/
      show_Distribution: false,
      /*批量选中ids*/
      batchIds: [],
    };
  },
  created() {
    let tabs = this.$db.getRouteField(this, 'tabs');
    let page = this.$db.getRouteField(this, 'page');
    let ordersearchForm = this.$db.getRouteField(this, 'ordersearchForm');
    if (tabs) this.activeName = tabs;
    if (page) this.curPage = page;
    if (ordersearchForm) this.searchForm = ordersearchForm;
    /*权限检测*/
    if(this.$filter.isAuth('/setting/distribution/dialog/distribution'))  this.show_Distribution = true;
    /*获取列表*/
    this.getData();

  },
  methods: {
    checkSelect(row,index){
      return !row.is_top_row && row.erp_status==0;
    },
    // 保存选中的数据id,row-key就是要指定一个key标识这一行的数据
    getRowKey (row) {
      return row.order_id;
    },
    /*监听复选按钮选中事件*/
    tableCurrentChange(val) {
      this.batchIds = [];
      val.forEach(e => {
        this.batchIds.push(e.order_id);
      });
    },
    /*跨多列*/
    arraySpanMethod(row) {
      if (row.rowIndex % 2 == 0) {
        if (row.columnIndex === 1) {
          return [1, 8];
        }
      }
    },
    /*选择第几页*/
    handleCurrentChange(val) {
      this.$db.setRoute(this, {'page': val});
      let self = this;
      self.curPage = val;
      self.getData();
    },
    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getData();
    },

    /*切换菜单*/
    handleClick(tab, event) {
      this.$db.setRoute(this, {'tabs': tab.name, 'page': 1});
      let self = this;
      self.curPage = 1;
      self.getData();
    },

    /*获取列表*/
    getData() {
      let self = this;
      let Params = this.searchForm;
      Params.dataType = self.activeName;
      Params.page = self.curPage;
      Params.list_rows = self.pageSize;
      self.loading = true;
      OrderApi.orderlist(Params, true)
        .then(res => {
          let list = [];
          for (let i = 0; i < res.data.list.data.length; i++) {
            let item = res.data.list.data[i];
            let topitem = {
              order_no: item.order_no,
              create_time: item.create_time,
              order_source:item.order_source,
              order_source_text:item.order_source_text,
              buyer_remark:item.buyer_remark,
              is_top_row: true
            };
            list.push(topitem);
            list.push(item);
          }
          self.tableData.data = list;

          self.totalDataNumber = res.data.list.total;
          self.exStyle = res.data.ex_style;
          self.payType = res.data.pay_type;
          self.shopList = res.data.shop_list;
          self.categoryList = res.data.catgory;
          self.order_count = res.data.order_count.order_count;
          self.loading = false;
        })
        .catch(error => {});
    },

    /*打开添加*/
    addClick(row) {
      let self = this;
      let params = row.order_id;
      self.$router.push({
        path: '/order/order/Detail',
        query: {
          order_id: params
        }
      });
    },

    /*打开编辑*/
    editClick(data,type) {
      if (type == 'express') {
        for (var i = data.product.length - 1; i >= 0; i--) {
          if (data.product[i].refund && data.product[i].refund.status.value == 0) {
            this.$message('售后未完成，不能去发货');
            return false;
          }
        }
      }
      this.dataModel = data;
      this.open_dialog[type] = true;
    },
    /*订单导出*/
    editeClick() {
      this.open_dialog.fileExport = true;
    },

    /*搜索查询*/
    onSubmit() {
      this.$db.setRoute(this, {'page': 1});
      this.$db.setRoute(this, {'ordersearchForm': this.searchForm});
      this.curPage = 1;
      this.tableData = [];
      this.getData();
    },
    /*批量发货*/
    openUpload() {
      this.open_add = true;
    },
    /*获取批量发货文件*/
    returnImgsFunc(e) {
      let self = this;
      if (e != null) {
        // this.file_id = e[0].file_id;
        // this.path = e[0].file_path;
        let params = {};
        params.file_id = e[0].file_id;
        self.loading = true;
        OrderApi.batchDelivery(params, true)
          .then(data => {
            self.loading = false;
            self.$message({
              message: data.msg,
              type: 'success'
            });
            self.$router.push('/order/order/index');
          })
          .catch(error => {
            self.loading = false;
          });

      }
      this.isupload = false;
    },

    onExport: function() {
      let self = this;
      let datascheck = self.datascheck;
      let searchForm = self.searchForm;
      let data1 = self.data1;
      let data = [datascheck,searchForm,data1];
      // console.log(data);
      let baseUrl = window.location.protocol + '//' + window.location.host;
      window.location.href = baseUrl + '/index.php/shop/order.operate/export?' + qs.stringify(data);
    },
    /*关闭弹窗*/
    closeDialogFunc(e, f) {
      if (f == 'add') {
        this.open_add = e.openDialog;
        this.getData();

      }
      if (f == 'edit') {
        this.open_edit = e.openDialog;
        this.getData();
      }
      if (f == 'express') {
        this.open_dialog.express = e.openDialog;
        this.getData();
      }
      if (f == 'track') {
        this.open_dialog.track = e.openDialog;
        this.getData();
      }
      if (f == 'extract') {
        this.open_dialog.extract = e.openDialog;
        this.getData();
      }
      if (f == 'fileExport') {
        this.open_dialog.fileExport = e.openDialog;
        this.getData();
      }
      if (f == 'pay_image') {
        this.open_dialog.pay_image = e.openDialog;
        this.getData();
      }

    },
    /*确认收货*/
    receiptClick(row){
      let self = this;
      self
        .$confirm('此操作将确定收货, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(() => {
          self.loading = true;
          OrderApi.orderReceipt(
            {
              order_id: row.order_id
            },
            true
          )
            .then(data => {
              self.$message({
                message: data.msg,
                type: 'success'
              });
              self.loading = false;
              self.getData();
            })
            .catch(error => {});
        })
        .catch(() => {});
    },

    /*确认付款*/
    payment(row){
      let self = this;
      self
        .$confirm('此操作将确认付款, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(() => {
          self.loading = true;
          OrderApi.orderPayment(
            {
              order_id: row.order_id
            },
            true
          )
            .then(data => {
              self.$message({
                message: data.msg,
                type: 'success'
              });
              self.loading = false;
              self.getData();
            })
            .catch(error => {});
        })
        .catch(() => {});
    },

    /*开始配送*/
    distribution(row){
      let self = this;
      self
        .$confirm('此操作将开始配送, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(() => {
          self.loading = true;
          OrderApi.distribution(
            {
              order_id: row.order_id
            },
            true
          )
            .then(data => {
              self.$message({
                message: data.msg,
                type: 'success'
              });
              self.loading = false;
              self.getData();
            })
            .catch(error => {});
        })
        .catch(() => {});
    },
    /*取消订单*/
    cancelClick(row){
      let self = this;
      self
        .$confirm('此操作将取消订单, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(() => {
          self.loading = true;
          OrderApi.cancel(
            {
              order_id: row.order_id
            },
            true
          )
            .then(data => {
              self.$message({
                message: data.msg,
                type: 'success'
              });
              self.loading = false;
              self.getData();
            })
            .catch(error => {});
        })
        .catch(() => {});
    },
    /*取消发货*/
    cancelExpress(row){
      let self = this;
      self
        .$confirm('此操作将取消发货, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(() => {
          self.loading = true;
          OrderApi.cancelExpress(
            {
              order_id: row.order_id
            },
            true
          )
            .then(data => {
              self.$message({
                message: data.msg,
                type: 'success'
              });
              self.loading = false;
              self.getData();
            })
            .catch(error => {});
        })
        .catch(() => {});
    },
    syncJushuitan(order_id=0){
      
      let self = this;
      self.$confirm('确认同步吗?', '提示', {
          type: 'warning'
        })
        .then(() => {
          OrderApi.syncJushuitan({
            order_id: order_id
          }).then(res => {
            console.log(res)
            self.$message({
              message: res.msg,
              type: 'success'
            });
            self.getData();
          });
        })
        .catch((res) => {
        });
    },
    syncWanliniu(order_id=0,batch=0){
      let self = this;
      let params = {
            order_id: order_id,
          };
      if(batch==1){
        params = {
            order_id: order_id,
            batchIds:self.batchIds
          };
      }
      if(batch==1 && self.batchIds.length==0){
        self.$message({
          message: '请选择订单',
          type: 'error'
        });
        return ;
      }
      self.$confirm('确认同步万里牛发货吗?', '提示', {
          type: 'warning'
        })
        .then(() => {
          
          OrderApi.syncWanliniu(params).then(res => {
            console.log(res)
            self.$message({
              message: res.msg,
              type: 'success'
            });
            self.getData();
          });
        })
        .catch((res) => {
        });
    },
  }
};
</script>
<style lang="scss">
.product-info {
  padding: 10px 0;
  border-top: 1px solid #eeeeee;
}
.order-code .state-text {
  padding: 2px 4px;
  border-radius: 4px;
  background: #808080;
  color: #ffffff;
}
.order-code .state-text-red{ background: red;}
.table-wrap .product-info:first-of-type {
  border-top: none;
}
.order_table-wrap .el-table__body tbody .el-table__row:nth-child(odd) {
  background: #f5f7fa;
}
</style>



// WEBPACK FOOTER //
// src/views/order/order/index.vue